module.exports = __webpack_public_path__ + "img/test.1643fd1d.png";